export const campaignTypeEnum = {
  bannerImage: 1,
  search: 2,

  getKeyByValue(value) {
    return Object.keys(this).find(key => this[key] === value);
  },
};

export const campaignZoneEnum = {
  pharmacyCategory: 'zone-e3a07490-f3f8-4bb8-b1e0-e542f3e169d7',
  pharmacySubCateogry: 'zone-b3ebf2a4-8487-4942-a3b8-5193d1cb4ef9',
  pharmacySearch: 'zone-0ed71cb1-52d8-4014-809e-afbcab75a24a',
  pharmacyHomeScreen: 'zone-e3a01190-f3f8-4b18-51e0-e542b9o163w1',

  getKeyByValue(value) {
    return Object.keys(this).find(key => this[key] === value);
  },
};
